import React from "react";
import { CustomTextField } from "../../components/TextFields";
import { Button } from "@mui/material";
import { ModalButtonContainer, NegativeModalButton, PositiveModalButton } from "../../components/Button";
import { useModal } from "../../components/modal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { SelectInput } from "../../components/inputs/SelectInput";
import { Row } from "../../global/styledComponents";

const schema = yup.object().shape({
    course: yup.string().required(" دوره الزامی است."),
    body: yup.string().required("بدنه الزامی است."),
    status: yup.string().required("وضعیت الزامی است."),
    writer: yup.string().required("نویسنده الزامی است."),
})
export default function AddModal() {
    const {
        setValue,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(schema),
    });
    const { setShow } = useModal();
    return (
        <React.Fragment>
            <Row gap=".5rem">
                <SelectInput
                    label="دوره"
                    error={!!errors.course}
                    helperText={errors.course?.message}
                    onChange={(e) => setValue("course", e?.value)}
                    required
                    options={[
                        { label: "دوره 2" },
                        { label: "دوره 3" },
                    ]} />
                <SelectInput
                    label="نویسنده"
                    error={!!errors.writer}
                    helperText={errors.writer?.message}
                    onChange={(e) => setValue("writer", e?.value)}
                    required
                    options={[
                        { label: "نویسنده" },
                        { label: "نویسنده2" },
                    ]} />
            </Row>
            <CustomTextField
                label="بدنه"
                required
                placeholder="بدنه را وارد کنید."
                variant="outlined"
                onChange={(e: any) => setValue("body", e.target.value)}
                value={watch("body")}
                error={!!errors.body}
                helperText={errors.body?.message}
                multiline
                minRows={2}
                maxRows={4}
            />
            <SelectInput
                label="وضعیت"
                error={!!errors.status}
                helperText={errors.status?.message}
                onChange={(e) => setValue("status", e?.value)}
                required
                options={[
                    { label: "درانتظار" },
                    { label: "تایید شده" },
                ]} />
            <ModalButtonContainer>
                <Button
                    style={NegativeModalButton}
                    sx={{
                        color: "divider",
                        bgcolor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "divider",
                        ":hover": {
                            bgcolor: "divider",
                            color: "primary.main"
                        },
                    }}
                    onClick={() => setShow(false)}
                >
                    انصراف
                </Button>
                <Button
                    style={PositiveModalButton}
                    sx={{
                        ":hover": {
                            bgcolor: "customColors.purple",
                            color: "secondary.main"
                        },
                    }}
                >
                    تایید
                </Button>
            </ModalButtonContainer >
        </React.Fragment>
    )
}